<template>
  <div
    id="transactions"
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      padding: '10px',
      // paddingTop: '0px',
      paddingTop: '20px',
      position: 'relative',
      bottom: '20px',
      minHeight: '100vh',
      height: 'auto'
    }"
  >
    <div class="padding-top-5"></div>
    <div class="gift-card margin-10">
      <div
        :style="{ backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff' }"
        style="padding: 5px; border-radius: 10px;"
        class="box-shadow"
        v-if="giftCards.length > 0 && dataLoaded"
      >
        <div
          :style="{ backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff' }"
          class="align-hor center-ver space-between bottom-border bg-light padding-10 pointer"
          v-on:click="goTogiftCardDetailPage(gc)"
          v-for="gc in giftCards"
          v-if="gc.is_active"
        >
          <div class="align-hor center-ver">
            <div class="w20 gift-card-image margin-right-10">
              <div v-if="gc.image_url">
                <img
                  class="full-width gift-card-image radius-5"
                  :src="gc.image_url"
                  @error="imageLoadOnError"
                />
              </div>
              <div class="dummy full-width bg-light-grey radius-5" v-else></div>
            </div>
            <div class="text-left">
              <div
                style="color: #757575; font-weight: 500;"
                class="margin-bottom-5 text-regular word-break"
              >
                {{ gc.name }}
              </div>
              <div
                class="text-semi-small text-light-grey"
                :style="{ color: isDarkTheme ? '#ffffff' : '#9A9A9A' }"
              >
                Value:
                <span class="font-bold" :style="{ color: '#323232' }">
                  <template v-if="gc.currency_code === 'INR'">
                    ₹{{ gc.value }}
                  </template>

                  <template v-else>
                    {{ gc.value }} {{ gc.currency_code }}
                  </template>
                </span>
              </div>
            </div>
          </div>
          <div
            class="wrap align-hor center-ver center-hor text-small pointer"
            @click.stop.prevent="toggleGiftModal(true, gc)"
            :style="{
              border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
              backgroundColor: '#ffffff',
              borderRadius: '20px',
              padding: '3px 7px'
            }"
          >
            <img
              class="smaller-icon pull-left margin-right-5"
              :src="walletActivecurrencyIcon.icon_url"
            />
            {{ gc.currency_req }}
          </div>
          <gift-popup v-if="gc.show_popup"></gift-popup>
        </div>
      </div>
      <div
        class="bg-light bottom-radius-5 padding-20 margin-bottom-10 pos-rel box-shadow align-ver center-hor center-ver"
        style="min-height: 70vh"
        v-else-if="giftCards.length === 0 && dataLoaded"
      >
        <img
          class="extra-large-icon margin-bottom-20"
          src="@/assets/no-data.svg"
        />
        <div class="margin-bottom-20">Nothing to Show</div>
      </div>

      <div
        class="bg-light box-shadow"
        v-if="giftCards.length == 0 && showShimmer"
        v-for="$i in 6"
      >
        <div
          class="align-hor center-ver space-between padding-10 bottom-border"
        >
          <div class="w70">
            <div class="align-hor center-ver">
              <div class="w20 margin-right-10">
                <div class="wrapper">
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                </div>
              </div>
              <div class="w40">
                <div class="wrapper">
                  <div class="comment animate margin-bottom-5 w85"></div>
                  <div class="comment animate w50"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="w15">
            <div class="wrapper">
              <div class="comment animate"></div>
              <div class="comment animate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import GiftCardPopup from "@/components/gift-card-popup";
export default {
  mixins: [globals],
  components: {
    "gift-popup": GiftCardPopup
  },
  data() {
    return {
      giftCards: [],
      is_shimmer: true,
      dataLoaded: false
    };
  },
  beforeMount() {
    this.loadDataFromCookie();
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  methods: {
    fetchGiftCards: function() {
      var url = this.$store.getters.flyyDomain + "/v2/gift_cards";
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers
        })
        .then(resp => {
          var all_gift_cards = resp.data.gift_cards;
          var tempArr = [];
          if (all_gift_cards && all_gift_cards.length > 0) {
            this.dataLoaded = true;
            all_gift_cards.forEach(gc => {
              // tempArr.push({
              //   id: gc.id,
              //   value: gc.value,
              //   is_active: gc.is_active,
              //   sku: gc.sku,
              //   name: gc.name,
              //   description: gc.description,
              //   image_url: gc.image_url,
              //   tnc_content: gc.tnc_content,
              //   expiry: gc.expiry,
              //   currency_req: gc.currency_req,
              //   currency_label: gc.currency_label,
              //   show_popup: false
              // });
              tempArr.push({
                id: gc.id,
                value: gc.value,
                is_active: gc.is_active,
                sku: gc.sku,
                name: gc.name,
                description: gc.description,
                image_url: gc.image_url,
                tnc_content: gc.tnc_content,
                expiry: gc.expiry,
                gc_source: gc.gc_source,

                // ✅ add these fields (missing earlier)
                currency_code: gc.currency_code,
                currency_name: gc.currency_name,
                show_rupee_value: gc.show_rupee_value,

                currency_req: gc.currency_req,
                currency_label: gc.currency_label,
                show_popup: false
              });
            });
          }
          this.giftCards = tempArr;
          this.is_shimmer = false;
        });
    },
    goTogiftCardDetailPage: function(gc) {
      this.$store.state.giftCardDetail = gc;
      this.redirectTo("gift-cards/" + gc.id);
    },
    imageLoadOnError(e) {
      e.target.src = "https://cdn.theflyy.com:9000/web-assets/gift-box.svg";
    }
  },
  created() {
    var store_state = this.$store.state;
    store_state.showHeader = true;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.headTitle = "Gift Cards";
    store_state.user.headerBalance.show = true;
    this.loadDataFromCookie();
    this.fetchGiftCards();
  }
};
</script>
<style>
.card-details {
  height: 250px;
  margin: auto 10px;
}
.gift-card .wrap {
  min-width: 55px;
}
.gift-card-image {
  min-width: 50px;
}
.gift-card-image .dummy {
  height: 30px;
}
</style>
